import { useMemo } from "react";

import { CommandPaletteBucket } from "../types";
import { BUCKET_IDS } from "../constants";
import useCommandPaletteAskInfraAssistantAction from "./useAskInfraAssistantAction";

const useCommandPaletteAskInfraAssistantBucket = (): CommandPaletteBucket => {
  const askAction = useCommandPaletteAskInfraAssistantAction();

  return useMemo(
    () => ({
      id: BUCKET_IDS.ASK_INFRA_ASSISTANT,
      title: "Infra Assistant",
      order: 1000,
      getActions: () => (askAction ? [askAction] : []),
    }),
    [askAction]
  );
};

export default useCommandPaletteAskInfraAssistantBucket;
